export default __webpack_public_path__ + "static/media/pantry1-afterH-1024w.f827ae4f.avif";